<template>
    <section class="works" @mouseleave="onLeave">

        <!-- home studio -->
        <work-item :bg-colour="'#E0EFDC'" :title="'Home Studio'" v-on:leave="onLeave">
            <p slot="description">
                Ingénieur du son en Home studio basé à Nouméa<br>
                <ul>
                    <li><span>Prise de son / enregistrement de voix et instruments / mixages</span></li>
                    <li>Compositions d’instrumentales</li>
                </ul>
            </p>
        </work-item>
        <!-- /home studio -->

        <!-- nc 1ere -->
        <work-item :bg-colour="'#F6EECE'" :title="'NC 1ère'" v-on:leave="onLeave">
            <p slot="description">
                Opérateur son - mixeur<br>
                <ul>
                    <li>Mixage JT, enregistrements, JT en direct</li>
                </ul>
            </p>
        </work-item>
        <!-- /nc 1ere -->

        <!-- the leftovers -->
        <work-item :bg-colour="'#F8E1CB'" :title="'The Leftovers'" v-on:leave="onLeave">
            <p slot="description">
                Compositions d’insutrumentales pour l’EP The Leftovers
            </p>
            <div slot="sounds">
                <sound :url="'/assets/sounds/the-leftovers/01-intro.mp3'" :title="'Intro'"></sound>
                <sound :url="'/assets/sounds/the-leftovers/02-action.mp3'" :title="'Action'"></sound>
                <sound :url="'/assets/sounds/the-leftovers/03-boite-a-musique.mp3'" :title="'Boite à musique'"></sound>
                <sound :url="'/assets/sounds/the-leftovers/04-cold.mp3'" :title="'Cold'"></sound>
            </div>
        </work-item>
        <!-- /the leftovers -->

        <!-- Section de recherches -->
        <work-item :bg-colour="'#F8E5EA'" :title="'Section de recherches'" v-on:leave="onLeave">
            <p slot="description">
                Tournage de la 13ème saison de la série télévisée métropolitaine Section de recherche en Nouvelle-Calédonie <br>
                <ul>
                    <li>3ème assistante réalisatrice lors des 2 épisodes tournés en NC</li>
                </ul>
            </p>
        </work-item>
        <!-- /Section de recherches -->

        <!-- Océania -->
        <work-item :bg-colour="'#E8DFEA'" :title="'Océania'" v-on:leave="onLeave">
            <p slot="description">
                Sonorisation de concerts et installation des écrans et lumières lors d’événements<br>
                <ul>
                    <li>Festival +687, fête de la musique (Paita)</li>
                    <li>Fête de la musique (Nouméa)</li>
                    <li>Anniversaire pour les 10 ans d’Océania (Port Moselle)</li>
                </ul>
            </p>
        </work-item>
        <!-- /Océania -->

        <!-- Sound design -->
        <work-item :bg-colour="'#D6E3F1'" :title="'Sound design'" v-on:leave="onLeave">
            <p slot="description">
                Animation d’ateliers de sound design : enregistrement de sons et bruitages et post-production sur animation vidéo<br>
                <ul>
                    <li>Festival des courts métrages de Nouméa pour la mairie de Nouméa</li>
                    <li>Festival des arts numériques pour l'association Jeunes et Toiles</li>
                </ul>
            </p>
        </work-item>
        <!-- /Sound design -->

        <!-- Instrumentales -->
        <work-item :bg-colour="'#F8EEE6'" :title="'Instrumentales'" v-on:leave="onLeave">
            <p slot="description">
                Compositions d’instrumentales aux styles divers (hip-hop, chill, reggae)
            </p>
            <div slot="sounds">
                <sound :url="'/assets/sounds/instrumentales/01-regarde.mp3'" :title="'Regarde'"></sound>
                <sound :url="'/assets/sounds/instrumentales/02-summertime.mp3'" :title="'Summertime theme'"></sound>
                <sound :url="'/assets/sounds/instrumentales/03-licorn-space.mp3'" :title="'Licorne space'"></sound>
                <sound :url="'/assets/sounds/instrumentales/04-sunshine.mp3'" :title="'Sunshine'"></sound>
                <sound :url="'/assets/sounds/instrumentales/05-sunset-lover.mp3'" :title="'Sunset Lover'"></sound>
                <sound :url="'/assets/sounds/instrumentales/06-swingtree.mp3'" :title="'Swing tree'"></sound>
            </div>
        </work-item>
        <!-- /Instrumentales -->

        <!-- Olivier Rouquier -->
        <work-item :bg-colour="'#D7E9E4'" :title="'Olivier Rouquier'" v-on:leave="onLeave">
            <p slot="description">
                Enregistrement guitare/chant du musicien Olivier Rouquier
            </p>
            <div slot="sounds">
                <sound :url="'/assets/sounds/olivier-rouquier/01-a-part.mp3'" :title="'À part'"></sound>
                <sound :url="'/assets/sounds/olivier-rouquier/02-apres-toi.mp3'" :title="'Après toi'"></sound>
                <sound :url="'/assets/sounds/olivier-rouquier/03-ce-que-je-vois.mp3'" :title="'Ce Que Je Vois'"></sound>
                <sound :url="'/assets/sounds/olivier-rouquier/04-mon-abri.mp3'" :title="'Mon Abri'"></sound>
                <sound :url="'/assets/sounds/olivier-rouquier/05-rose-mary.mp3'" :title="'Rose Mary'"></sound>
            </div>
        </work-item>
        <!-- /Olivier Rouquier -->

        <!-- Alarme -->
        <work-item :bg-colour="'#E3F1DD'" :title="'Alarme'" v-on:leave="onLeave">
            <p slot="description">
                <ul>
                    <li>Sound design et compositions personnelles (instrumentale)</li>
                    <li>Enregistrements de bruitages avec Zoom H4N Pro et micro BlueBird</li>
                </ul>
                <br>
                <a class="links" @click="openModal">Voir la vidéo</a>
                <br>
                <br>
                Crédits : animation et vidéo par Moo-hyun Jang. <br>
                Vidéo originale sur : <a class="links" href="https://www.youtube.com/watch?v=Lc-vINJmhNk" rel="noopener noreferrer" target="_blank">Youtube</a><br><br>
            </p>
        </work-item>
        <!-- /Alarme -->

        <!-- L'anomalie -->
        <work-item :bg-colour="'#EEEEEE'" :title="'L\'Anomalie'" v-on:leave="onLeave">
            <p slot="description">
                Enregistrement de voix du rappeur L'anomalie et mixage
            </p>
            <div slot="sounds">
                <sound :url="'/assets/sounds/l-anomalie/01-crash-test.mp3'" :title="'Crash test'"></sound>
                <sound :url="'/assets/sounds/l-anomalie/02-aristote.mp3'" :title="'Aristote'"></sound>
                <sound :url="'/assets/sounds/l-anomalie/03-la-zermi.mp3'" :title="'La Zermi'"></sound>
                <sound :url="'/assets/sounds/l-anomalie/04-flash.mp3'" :title="'Flash'"></sound>
            </div>
        </work-item>
        <!-- /L'anomalie -->

        <!-- modal -->
        <modal :is-open="isModalOpen" :clickOutside="closeModal">
            <fade-scale-transition>
                <iframe :key="'iframe'" src="https://player.vimeo.com/video/315131304" v-show="isIframeLoaded" @load="iframeLoaded" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                <loader :key="'loader'" v-show="!isIframeLoaded" :size="'large'" :theme="'light'"></loader>
            </fade-scale-transition>
        </modal>
        <!-- /modal -->
    </section>
</template>
<script>
    import anime from 'animejs'
    import classes from 'dom-classes'
    import Modal from 'vue-slim-modal'
    import Loader from '@/components/Loader'
    import Sound from '@/components/Sound'
    import WorkItem from '@/components/WorkItem.vue'
    export default {
        name: 'works',
        components: {
            Sound,
            WorkItem,
            Modal,
            Loader
        },
        data() {
            return {
                isModalOpen: false,
                isIframeLoaded: false
            }
        },
        methods: {
            onLeave() {
                anime({
                    targets: '#app',
                    background: '#FFF6EC',
                    duration: 600,
                    easing: 'easeInOutCubic'
                })
            },
            closeModal() {
                this.isModalOpen = false
                this.isIframeLoaded = false
                classes.remove(document.body, 'noscroll')
            },
            openModal() {
                classes.add(document.body, 'noscroll')
                this.isModalOpen = true
            },
            iframeLoaded() {
                this.isIframeLoaded = true
            }
        }
    }
</script>
<style>
</style>